export const formatValueToServerData = (values) => ({
  name: values.name,
})
